import * as Constants from '../../../constants';

import { faClose, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaLink } from "react-icons/fa";
import { Formik } from "formik";
import { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import * as Yup from "yup";

export default function ExternalSystemFormModal({ show, onHide, onSave, externalSystem }) {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [externalSystems, setExternalSystems] = useState([]);
    console.warn(externalSystem)

    const validationSchema = Yup.object({

        title: Yup.string()
            .trim()
            .required("Informe o título"),

        custom: Yup.string()
            .required("Selecione uma opção"),

        status: Yup.string()
            .required("Selecione uma opção"),
    });

    const initialValues = {
        title: externalSystem?.title || "",
        link: externalSystem?.link || "",
        description: externalSystem?.description || "",
        status: externalSystem?.status || "0"
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setIsLoading(true);
                const token = localStorage.getItem("token");

                const headers = {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                };

                const [
                    // usersRes,
                    externalSystemsRes,
                    externalSystemTypesRes,
                    statusTypesRes
                ] = await Promise.all([
                    fetch(Constants.EXTERNAL_SYSTEMS_LIST, { signal, headers })
                ]);

                const externalSystemsJson = await externalSystemsRes.json();

                if (externalSystemsJson.status === "success")
                    setExternalSystems(externalSystemsJson.data);
            } catch (error) {
                if (error.name === "AbortError") return;
                console.error("Erro:", error);
            } finally {
                setIsLoading(false);
            }

        };

        fetchData();

        return () => controller.abort();

    }, []);

    return (

        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
                alert('bagaça')
                const data = externalSystem
                    ? { ...values, id: externalSystem.id }
                    : values;

                onSave(data);

                resetForm();
                onHide();

            }}
        >

            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (

                <Modal show={show} onHide={onHide} centered>

                    <Modal.Header closeButton className="bg-light">
                        <Modal.Title>
                            {externalSystem ? "Editar Sistema Externo" : "Cadastrar Sistema Externo"}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Form noValidate>
                            {/* title */}

                            <Form.Group className="mb-3">

                                <Form.Label>Título</Form.Label>

                                <Form.Control
                                    name="title"
                                    value={values.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.title && !!errors.title}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.title}
                                </Form.Control.Feedback>

                            </Form.Group>

                            {/* link */}
                            <Form.Group className="mb-3">

                                <Form.Label>Link</Form.Label>&nbsp;{ values.link ? <small><a href=''><FaLink /></a></small>: '' }

                                <Form.Control
                                    name="link"
                                    value={values.link}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.link && !!errors.link}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.link}
                                </Form.Control.Feedback>

                            </Form.Group>

                            {/* description */}
                            <Form.Group className="mb-3">

                                <Form.Label>Descrição</Form.Label>

                                <Form.Control
                                    name="description"
                                    as="textarea"
                                    rows={3}
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.description && !!errors.description}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.description}
                                </Form.Control.Feedback>

                            </Form.Group>


                            {/* Status */}

                            <Form.Group className="mb-3">
                                <Form.Label className="d-block">Status da Sistema Externo</Form.Label>

                                <div className="d-flex gap-3">
                                    <Form.Check
                                        type="radio"
                                        label={<span>Habilitada</span>}
                                        name="status"
                                        id="status-active"
                                        value="1"
                                        checked={values.status == 1}
                                        onChange={handleChange}
                                        isInvalid={touched.status && !!errors.status}
                                    />

                                    <Form.Check
                                        type="radio"
                                        label={<span>Desabilitada</span>}
                                        name="status"
                                        id="status-inactive"
                                        value="0"
                                        checked={values.status == 0}
                                        onChange={handleChange}
                                        isInvalid={touched.status && !!errors.status}
                                    />
                                </div>

                                {touched.status && errors.status && (
                                    <div className="text-danger small mt-1">
                                        {errors.status}
                                    </div>
                                )}
                            </Form.Group>

                        </Form>

                    </Modal.Body>


                    <Modal.Footer>

                        <Button variant="outline-secondary" onClick={onHide}>
                            <FontAwesomeIcon icon={faClose} /> Cancelar
                        </Button>

                        <Button variant="primary" onClick={handleSubmit}>
                            <FontAwesomeIcon icon={faFloppyDisk} /> Salvar
                        </Button>

                    </Modal.Footer>

                </Modal>

            )}

        </Formik>

    );

}
